import React, { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
// Components
import {
  FormLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
// Types
import { IOrderHistory } from '../../../models';
import { UNDEFINED_PART } from '../../../helpers';

interface IMobilePartsHistory {
  original: IOrderHistory;
  setShowPartHistoryOrderModal: (val: any) => void;
  setFieldOrderId: (val: any) => void;
}

export const MobilePartsHistory: FC<IMobilePartsHistory> = ({
  original,
  setShowPartHistoryOrderModal,
  setFieldOrderId
}) => {
  const classes = useStyles();
  const { part, dateOrdered, quantity, status, fieldOrderId } = original;

  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">
            <span className={part === UNDEFINED_PART ? classes.undefinedPart : undefined}>
              {part}
            </span>
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Date:
          </FormLabel>
          <Typography component="span" variant="body2">
            {dateOrdered || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Order:
          </FormLabel>
          <Button
            onClick={e => {
              setShowPartHistoryOrderModal(true);
              setFieldOrderId(fieldOrderId);
            }}
            variant="text"
            color="primary"
            className={classes.fieldOrderId}
          >
            {fieldOrderId}
          </Button>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Part:
          </FormLabel>
          <Typography
            component="span"
            variant="body2"
            className={part === UNDEFINED_PART ? classes.undefinedPart : undefined}
          >
            {part || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Qty.:
          </FormLabel>
          <Typography component="span" variant="body2">
            {quantity || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Status:
          </FormLabel>
          <Typography component="span" variant="body2">
            {status || '--'}
          </Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  roleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  editButton: {
    padding: `2px 5px`
  },
  deleteButton: {
    padding: `2px 5px`,
    color: theme.palette.error.main
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  buttonsWrapper: {
    display: 'flex'
  },
  undefinedPart: {
    color: theme.palette.error.main
  },
  fieldOrderId: {
    fontSize: '1rem',
    padding: 0,
    marginLeft: '-5px'
  }
}));
